// extracted by mini-css-extract-plugin
module.exports =  {"report-button":"_32bbee5fda--report-button--xxAhj","report-button-text":"_32bbee5fda--report-button-text--e0KNb","button-active":"_32bbee5fda--button-active--GibBU"};